import { jsx as _jsx } from "react/jsx-runtime";
import Flex from '../atoms/Flex';
import PaginationItem from '../atoms/PaginationItem';
const PaginationList = ({ links, setPage, disabled, }) => {
    const updatePage = (e, link) => {
        e.preventDefault();
        if (link.url) {
            const url = new URL(link.url, 'http://localhost');
            setPage(Number(url.searchParams.get('page')));
        }
        else {
            setPage(1);
        }
    };
    return (_jsx(Flex, { alignItems: "center", justifyContent: "flex-end", margin: "30px 0 0", children: links.map((link, index) => (_jsx(PaginationItem, { disabled: disabled, href: link.url || undefined, label: link.label, isFirst: index === 0, isLast: index === links.length - 1, isActive: link.active, onClick: (e) => updatePage(e, link) }, index))) }));
};
export default PaginationList;
